import type { ComputedRef, InjectionKey } from 'vue';

export const SIDEBAR_TRANSITION = 'all 100ms linear';

export const SIDEBAR_COLLAPSED_KEY: InjectionKey<ComputedRef<boolean>> =
  Symbol('sidebarCollapsed');
